// src/pages/doctor/AddDoctorAvailability.jsx
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getRequest,  } from "../../apis/ApiInstence"; // ✅ wrapper for axios

const AddDoctorAvailability = () => {
  const [formData, setFormData] = useState({
    doctor_name: "",
    opd_type: "",
    opd_location: "",
    available_date: "",
    time_slot: "",
  });

  const [meta, setMeta] = useState({
    doctors: [],
    opd_types: [],
    opd_locations: [],
    schedules: {},
  });

  const [slots, setSlots] = useState([]);
  const [loading, ] = useState(false);
  const navigate = useNavigate();

  // ✅ Fetch dropdown options from backend
  useEffect(() => {
    const fetchMeta = async () => {
      try {
        const res = await getRequest("doctor_availability/meta");
        setMeta(res.data); // expected: { doctors, opd_types, opd_locations, schedules }
      } catch (err) {
        console.error("Error fetching meta:", err);
        toast.error("Could not load form options. Check server.");
      }
    };
    fetchMeta();
  }, []);

  // ✅ Generate time slots
  const generateSlots = (startHHMM, endHHMM, slotMinutes) => {
    if (!startHHMM || !endHHMM || !slotMinutes) return [];
    const [sH, sM] = startHHMM.split(":").map(Number);
    const [eH, eM] = endHHMM.split(":").map(Number);

    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth(), today.getDate(), sH, sM);
    const end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), eH, eM);

    const out = [];
    const addMinutes = (date, mins) => new Date(date.getTime() + mins * 60000);

    let cur = new Date(start);
    while (addMinutes(cur, slotMinutes) <= end) {
      const next = addMinutes(cur, slotMinutes);
      const fmt = (d) => {
        let h = d.getHours();
        const m = d.getMinutes().toString().padStart(2, "0");
        const ampm = h >= 12 ? "PM" : "AM";
        h = h % 12 || 12;
        return `${h}:${m} ${ampm}`;
      };
      out.push(`${fmt(cur)} - ${fmt(next)}`);
      cur = next;
    }
    return out;
  };

  // ✅ Update slots whenever doctor changes
  useEffect(() => {
    const { doctor_name } = formData;
    if (!doctor_name) {
      setSlots([]);
      return;
    }
    const schedule = meta.schedules?.[doctor_name];
    if (!schedule) {
      setSlots([]);
      return;
    }
    const generated = generateSlots(schedule.start, schedule.end, schedule.slotDurationMin);
    setSlots(generated);

    // Reset invalid slot
    if (formData.time_slot && !generated.includes(formData.time_slot)) {
      setFormData((prev) => ({ ...prev, time_slot: "" }));
    }
  }, [formData.doctor_name, meta.schedules]);

  // ✅ Handle form change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ✅ Handle submit
 const handleSubmit = async (e) => {
  e.preventDefault();

  const formDataToSend = new FormData();
  for (const key in formData) {
    if (key === 'images' && formData.images) {
      formData.images.forEach((file) => {
        formDataToSend.append('images', file);
      });
    } else {
      formDataToSend.append(key, formData[key]);
    }
  }

  try {
    await dispatch(addProduct(formDataToSend)).unwrap(); // ✅ wait and throw on error
    toast.success('Product added successfully!');
    navigate('/products'); // ✅ navigate only after success
  } catch (error) {
    console.error('There was a problem adding the product:', error);
    toast.error(error?.message || 'Failed to add product'); // ✅ show error toast
  }
};


  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Doctor Availability</h4>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="row mx-4">
          {/* Doctor Name */}
          <div className="col-sm-12 mt-4">
            <label className="adminlables" htmlFor="doctor_name">
              Doctor Name
            </label>
            <select
              id="doctor_name"
              name="doctor_name"
              value={formData.doctor_name}
              onChange={handleChange}
              className="form-control"
              required
            >
              <option value="">Select Doctor</option>
              {meta.doctors.map((d) => (
                <option key={d} value={d}>
                  {d}
                </option>
              ))}
            </select>
          </div>

          {/* OPD Type */}
          <div className="col-sm-12 mt-4">
            <label className="adminlables" htmlFor="opd_type">
              OPD Type
            </label>
            <select
              id="opd_type"
              name="opd_type"
              value={formData.opd_type}
              onChange={handleChange}
              className="form-control"
              required
            >
              <option value="">Select OPD Type</option>
              {meta.opd_types.map((t) => (
                <option key={t} value={t}>
                  {t === "visit-opd" ? "Visit OPD" : "Telemedicine"}
                </option>
              ))}
            </select>
          </div>

          {/* OPD Location */}
          <div className="col-sm-12 mt-4">
            <label className="adminlables" htmlFor="opd_location">
              OPD Location
            </label>
            <select
              id="opd_location"
              name="opd_location"
              value={formData.opd_location}
              onChange={handleChange}
              className="form-control"
              required
            >
              <option value="">Select Location</option>
              {meta.opd_locations.map((loc) => (
                <option key={loc} value={loc}>
                  {loc}
                </option>
              ))}
            </select>
          </div>

          {/* Available Date */}
        {/* Available Date */}
<div className="col-sm-12 mt-4">
  <label className="adminlables" htmlFor="available_date">
    Available Date
  </label>
  <input
    id="available_date"
    type="date"
    name="available_date"
    value={formData.available_date}
    onChange={handleChange}
    className="form-control"
    required={formData.opd_type === "visit-opd"}
  />
  {formData.opd_type === "telemedicine" && (
    <small className="form-text text-muted">
      Leave empty for &quot;All Days&quot; (telemedicine).
    </small>
  )}
</div>


          {/* Time Slot */}
          <div className="col-sm-12 mt-4">
            <label className="adminlables" htmlFor="time_slot">
              Time Slot
            </label>
            {slots.length > 0 ? (
              <select
                id="time_slot"
                name="time_slot"
                value={formData.time_slot}
                onChange={handleChange}
                className="form-control"
                required
              >
                <option value="">Select Time Slot</option>
                {slots.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            ) : (
              <input
                id="time_slot"
                type="text"
                name="time_slot"
                value={formData.time_slot}
                onChange={handleChange}
                placeholder="Auto-generated time slots will appear after selecting doctor"
                className="form-control"
                required
              />
            )}
          </div>
        </div>

        {/* Submit */}
        <div className="mt-4 text-right mx-4">
          <button className="btn btn-lg addbtn" disabled={loading}>
            {loading ? "Adding..." : "Add Availability"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddDoctorAvailability;
